import React from 'react';
import { Route } from 'react-router-dom';
import FirstPage from './actualContainers/FirstPageView';
import WorkArea from './actualContainers/WorkAreaView';
import HistoryList from './actualContainers/HistoryListView';
import Login from './containers/Login';
import Signup from "./containers/Signup"; 

const BaseRouter = (props) =>{ 
    return (
        <div> 
            
            <Route exact path='/'  render={(routeProps) => <FirstPage {...routeProps} {...props} />}/>
            <Route exact path='/workArea/:documentID/' component={WorkArea} />
            <Route exact path='/HistoryList/' component={HistoryList}/>
            <Route exact path='/login/' component={Login}/>
            <Route exact path="/signup/" component={Signup } /> 
            
          </div>
    ); 
}; 

export default BaseRouter;     